<template>
  <span class="error-icon">
    <span class="error-icon__body">!</span>
  </span>
</template>

<script>
export default {
  name: 'ErrorIcon',
};
</script>

<style lang="scss" scoped>
  .error-icon {
    --size: 16px;
    --padding: 4px;

    padding: var(--padding);
    display: inline-block;
    cursor: pointer;
  }

  .error-icon__body {
    --icon-background-color: #{$color--error};
    --icon-color: #{$color--basic-white};
    width: var(--size);
    height: var(--size);
    border-radius: 50%;
    background-color: var(--icon-background-color);
    color: var(--icon-color);
    display: grid;
    place-items: center;
    font-size: $text-11px;
    line-height: var(--size);
  }
</style>
